export const messages = {
  en: {
    ownerCommitteeManage: {
      searchTitle: 'Search Conditions',
      namePlaceholder: 'Please enter name',
      phonePlaceholder: 'Please enter phone number',
      statePlaceholder: 'Please select status',
      onDuty: 'On Duty',
      resigned: 'Resigned',
      listTitle: 'Owner Committee',
      id: 'ID',
      name: 'Name',
      gender: 'Gender',
      phone: 'Phone',
      idCard: 'ID Card',
      address: 'Address',
      position: 'Position',
      post: 'Post',
      appointTime: 'Appoint Time',
      term: 'Term',
      status: 'Status',
      deleteTitle: 'Confirm Operation',
      deleteConfirm: 'Are you sure to delete this committee member?',
      deleteSuccess: 'Delete successful',
      fetchError: 'Failed to fetch committee list',
      deleteError: 'Failed to delete committee member'
    }
  },
  zh: {
    ownerCommitteeManage: {
      searchTitle: '查询条件',
      namePlaceholder: '请输入姓名',
      phonePlaceholder: '请输入电话',
      statePlaceholder: '请选择状态',
      onDuty: '在职',
      resigned: '离职',
      listTitle: '业委会',
      id: '编号',
      name: '姓名',
      gender: '性别',
      phone: '电话',
      idCard: '身份证',
      address: '住址',
      position: '职位',
      post: '岗位',
      appointTime: '届期',
      term: '任期',
      status: '状态',
      deleteTitle: '确认操作',
      deleteConfirm: '确定删除该业委会成员吗？',
      deleteSuccess: '删除成功',
      fetchError: '获取业委会列表失败',
      deleteError: '删除业委会成员失败'
    }
  }
}